import { doodBlockConfig, propertyValue } from "./dood-block-config";
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from "./descriptor-field-order";
import type { IBlockDescriptor } from "./descriptor";

export const SIMPLEHEADERIMAGEITEMBLOCK_LEGACY_FIELD_ORDER = [
  "image",
  "link_url",
  "link_target",
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  simpleHeaderImageItemBlockDescriptor: _generatedSimpleHeaderImageItemBlockDescriptor,
  simpleHeaderImageItemBlockBlocDefinition,
  simpleHeaderImageItemBlockDashboardLayout,
  simpleHeaderImageItemBlockConfig,
  simpleHeaderImageItemBlockResolveConfig,
  simpleHeaderImageItemBlockProperties,
} = doodBlockConfig(
  {
    name: "Image item",
    componentType: "SimpleHeaderImageItemBlockComponent",
    category: "navigation",
    description: "Image item.",
    keywords: [],
    allowedIn: [
      { bloc: "SimpleHeaderBlockComponent", slot: "left_items" },
      { bloc: "SimpleHeaderBlockComponent", slot: "middle_items" },
      { bloc: "SimpleHeaderBlockComponent", slot: "right_items" },
    ],
    sharedFields: {},
  },

  () => ({
    image: propertyValue({
      type: "image",
      value: "",
      options: {
        label: "pages.blocks.simple-header-image-item.image.label",
        help: "pages.blocks.simple-header-image-item.image.help",
      },
    }),
    link_url: propertyValue({
      type: "text",
      value: "",
      options: {
        label: "pages.blocks.simple-header-image-item.link-url.label",
        help: "pages.blocks.simple-header-image-item.link-url.help",
      },
    }),
    link_target: propertyValue({
      type: "select",
      value: "_self",
      options: {
        label: "pages.blocks.simple-header-image-item.link-target.label",
        choices: [
          {
            value: "_self",
            label: "pages.blocks.simple-header-image-item.link-target.options.self",
          },
          {
            value: "_blank",
            label: "pages.blocks.simple-header-image-item.link-target.options.blank",
          },
        ],
      },
    }),
  }),

  () => ({
    tabs: [
      {
        label: "pages.blocks.simple-header-image-item.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.simple-header-image-item.fieldset.image.label",
            fields: ["image"],
          },
          {
            legend: "pages.blocks.simple-header-image-item.fieldset.link.label",
            fields: ["link_url", "link_target"],
          },
        ],
      },
    ],
  }),
);

export function simpleHeaderImageItemBlockDescriptor(): IBlockDescriptor;
export function simpleHeaderImageItemBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function simpleHeaderImageItemBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedSimpleHeaderImageItemBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(
    _generatedSimpleHeaderImageItemBlockDescriptor,
    simpleHeaderImageItemBlockProperties,
    fieldOrder,
  );
}

export {
  simpleHeaderImageItemBlockBlocDefinition,
  simpleHeaderImageItemBlockDashboardLayout,
  simpleHeaderImageItemBlockProperties,
  simpleHeaderImageItemBlockConfig,
  simpleHeaderImageItemBlockResolveConfig,
};

export type SimpleHeaderImageItemBlockConfig = typeof simpleHeaderImageItemBlockConfig;
